import React, { useRef } from 'react'
import { SnackbarProvider as NotiStackProvider, MaterialDesignContent } from 'notistack'
import { styled } from '@mui/styles'
import IconButton from '@mui/material/IconButton'
import { SnackbarUtilsConfigurator } from '../../config/snack-actions'
import { CloseIcon } from '../../components/icons/close-icon'
import { ErrorIcon } from '../../components/icons/error-icon'
import { DoneIcon } from '../../components/icons/done-icon'

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
    '&.notistack-MuiContent': {
        borderRadius: 8,
        fontSize: 12,
        fontWeight: 500,
        minHeight: 34,
        padding: '0 10px',
        '& > div:last-of-type': {
            marginRight: 0,
        },
    },

    '&.notistack-MuiContent-success': {
        backgroundColor: '#5DC887',

        '& div[id="notistack-snackbar"]': {
            padding: 0,
        },
    },

    '& div[id="notistack-snackbar"]': {
        gap: '10px',
    },
}))

const SnackbarCloseButton = ({ onClick }) => (
    <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={onClick}
        sx={{
            '&:hover': {
                background: 'transparent',
            },
            '&:focus': {
                outline: 'none',
            },
        }}
    >
        <CloseIcon />
    </IconButton>
)

export const SnackbarProvider = ({ children }) => {
    const notistackRef = useRef()
    const onClickDismiss = key => () => {
        notistackRef.current.closeSnackbar(key)
    }

    return (
        <NotiStackProvider
            ref={notistackRef}
            maxSnack={1}
            Components={{
                success: StyledMaterialDesignContent,
                error: StyledMaterialDesignContent,
            }}
            iconVariant={{
                success: <DoneIcon />,
                error: <ErrorIcon />,
            }}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            action={key => <SnackbarCloseButton onClick={onClickDismiss(key)} />}
        >
            <SnackbarUtilsConfigurator />
            {children}
        </NotiStackProvider>
    )
}
